/**
 * Wires the S3 `setTileDangerousConfirmer` seam to the app's real
 * destructive-confirm dialog (S6). The ACTIVE dashboard tab owns the
 * confirmer (re-registered on activation) so a closed tab's dead dialog can
 * never swallow a manual run's confirmation.
 */
import { useEffect, useState } from 'react';
import { DangerousQueryDialog } from '../../query-editor/components/DangerousQueryDialog';
import { setTileDangerousConfirmer } from '../services/tileExecutionService';

type PendingConfirm = {
  reason: string;
  resolve: (confirmed: boolean) => void;
};

export function TileDangerousConfirmHost({ active }: { active: boolean }) {
  const [pending, setPending] = useState<PendingConfirm | null>(null);

  useEffect(() => {
    if (!active) return;
    setTileDangerousConfirmer(
      (reason) =>
        new Promise<boolean>((resolve) => {
          setPending({ reason, resolve });
        }),
    );
  }, [active]);

  const settle = (confirmed: boolean) => {
    pending?.resolve(confirmed);
    setPending(null);
  };

  if (!pending) return null;
  return (
    <DangerousQueryDialog
      open
      dangerInfo={{ dangerous: true, severity: 'high', reason: pending.reason }}
      onConfirm={() => settle(true)}
      onCancel={() => settle(false)}
    />
  );
}
